import React from 'react';

export const StyleEdit = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.753 18H15.881C15.671 18 15.497 17.949 15.359 17.847C15.227 17.739 15.131 17.607 15.071 17.451L14.099 14.796H8.708L7.736 17.451C7.688 17.589 7.592 17.715 7.448 17.829C7.31 17.943 7.139 18 6.935 18H5.054L10.166 4.986H12.641L17.753 18ZM9.329 13.086H13.478L11.894 8.757C11.822 8.565 11.741 8.34 11.651 8.082C11.567 7.818 11.483 7.533 11.399 7.227C11.315 7.533 11.231 7.818 11.147 8.082C11.069 8.346 10.991 8.577 10.913 8.775L9.329 13.086Z"
      fill="black"
    />
    <line
      stroke="black"
      strokeWidth="1.54"
      x1="5"
      x2="18"
      y1="21.23"
      y2="21.23"
    />
  </svg>
);
